buyBonusButton = {};

buyBonusButton.create = function () {
  var button = new PIXI.Container();

  InputHelpers.addGenerics(button);
  InputHelpers.addAutoplayFlag(button);
  InputHelpers.addCanSpinFlag(button);
  InputHelpers.addInfoPlatformEnabledFlag(button);

  button.bonusEnabled = gdk.getPlatformAllowsBuyBonus();

  button._potBonusActive = false;

  button._flags.credit = {
    balance: 0,
  };

  button.canEnable = function () {
    if (checkForUndefined(this.gameConfig)) return false;

    const { BONUS_BUY_LOW, BONUS_BUY_MED, BONUS_BUY_HIGH } = this.gameConfig.data.slotConfig.gameModes;

    let validStake = false;
    if (
      BONUS_BUY_LOW !== undefined &&
      BONUS_BUY_MED !== undefined &&
      BONUS_BUY_HIGH !== undefined &&
      BONUS_BUY_LOW.coinSizes.length > 0 &&
      BONUS_BUY_MED.coinSizes.length > 0 &&
      BONUS_BUY_HIGH.coinSizes.length > 0
    ) {
      validStake = true;
    }
    var canEnable =
      this._flags.canSpin &&
      !this._flags.autoplayStarted &&
      !this._flags.modal.active &&
      !button._sideMenuOpen &&
      validStake &&
      !button.isPromotion;

    resourceManager.get(this.name + ":button").alpha = canEnable ? 1 : 0.5;

    return canEnable;
  };

  button.canShow = function () {
    if (checkForUndefined(this.gameConfig)) return false;

    const { BONUS_BUY_LOW, BONUS_BUY_MED, BONUS_BUY_HIGH } = this.gameConfig.data.slotConfig.gameModes;

    const canShowButton =
      gdk.getPlatformAllowsBuyBonus() &&
      this.allowBonusBuy !== false &&
      BONUS_BUY_LOW !== undefined &&
      BONUS_BUY_MED !== undefined &&
      BONUS_BUY_HIGH !== undefined &&
      BONUS_BUY_LOW.coinSizes.length > 0 &&
      BONUS_BUY_MED.coinSizes.length > 0 &&
      BONUS_BUY_HIGH.coinSizes.length > 0 &&
      gdk.getRegulatedMarket() !== "UK" &&
      !button._potBonusActive;

    return canShowButton;
  };

  button.onPressedCallback = function () {
    // disable lucky bet button
    buyBonusPopup.show(function () {});
    resourceManager.get("buttonContainer:buttonBar:luckyBetToggleButton").enterBuyABonus();

    if (button.soundName !== "") button.playSound();
  };

  button.onGameConfig = function (event) {
    this.allowBonusBuy = gdk.getConfigValue("AllowBuyBonus");
    this.gameConfig = event;
  };

  button.onCreditChanged = function (creditTask) {
    this._flags.credit.balance = creditTask.data.balance;
  };

  button.onStakeChanged = function (stake) {
    this._flags.stake = stake;
  };

  button.promotionStarted = function () {
    button.isPromotion = true;
  };

  button.promotionEnded = function () {
    button.isPromotion = false;
  };

  button.sideMenuOpenMsg = function () {
    button._sideMenuOpen = true;
  };

  button.sideMenuClosedMsg = function () {
    button._sideMenuOpen = false;
  };

  button.onPotBonusStartEvent = function () {
    button._potBonusActive = true;
  };

  button.onPotBonusStartEventDead = function () {
    button._potBonusActive = false;
  };

  messageBus.subscribe("game:sideMenuOpen", button.sideMenuOpenMsg.bind(button));
  messageBus.subscribe("game:sideMenuClosed", button.sideMenuClosedMsg.bind(button));
  messageBus.subscribe("common:BalanceEvent", button.onCreditChanged.bind(button));
  messageBus.subscribe("spinner:GameConfigEvent", button.onGameConfig.bind(button));
  messageBus.subscribe("stake:stakeChanged", button.onStakeChanged.bind(button));
  messageBus.subscribe("common:PromotionStarted", button.promotionStarted.bind(button));
  messageBus.subscribe("common:PromotionEnded", button.promotionEnded.bind(button));

  return button;
};

buyBonusButton.initialise = function (json, object) {
  object.soundName = json.soundName || "";
};

buyBonusButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "buyBonusButton",
  buyBonusButton.create,
  buyBonusButton.initialise,
  buyBonusButton.getFilesRequired
);
